// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _proprietaMisurataUtilsData = {
  Temperatura: {
    label: "Temperatura",
    labelWithArticle: "la temperatura",
    shortLabel: "Temp.",
    unit: "°C",
    unitPosition: "right",
    percentMin: 0.0,
    percentMax: 100.0,
    order: 100,
    colorHex: "#0074D9",
  },
  Particelle: {
    label: "Numero di particelle (deprecato)",
    labelWithArticle: "il numero di particelle",
    shortLabel: "N° Part.",
    unit: null,
    unitPosition: null,
    percentMin: 10.0,
    percentMax: 30.0,
    order: 1000,
    colorHex: null,
  },
  Particelle_iso4: {
    label: "Numero di particelle (ISO 4)",
    labelWithArticle: "il numero di particelle",
    shortLabel: "ISO 4",
    unit: null,
    unitPosition: null,
    percentMin: 10.0,
    percentMax: 30.0,
    order: 1010,
    colorHex: "#FF4136",
  },
  Particelle_iso6: {
    label: "Numero di particelle (ISO 6)",
    labelWithArticle: "il numero di particelle",
    shortLabel: "ISO 6",
    unit: null,
    unitPosition: null,
    percentMin: 10.0,
    percentMax: 30.0,
    order: 1020,
    colorHex: "#FF851B",
  },
  Particelle_iso14: {
    label: "Numero di particelle (ISO 14)",
    labelWithArticle: "il numero di particelle",
    shortLabel: "ISO 14",
    unit: null,
    unitPosition: null,
    percentMin: 10.0,
    percentMax: 30.0,
    order: 1030,
    colorHex: "#CC7722",
  },
  Particelle_iso21: {
    label: "Numero di particelle (ISO 21)",
    labelWithArticle: "il numero di particelle",
    shortLabel: "ISO 21",
    unit: null,
    unitPosition: null,
    percentMin: 10.0,
    percentMax: 30.0,
    order: 1040,
    colorHex: "#FFDC00",
  },
  Pressione: {
    label: "Pressione",
    labelWithArticle: "la pressione",
    shortLabel: "Pressione",
    unit: "bar",
    unitPosition: "right",
    percentMin: 0.0,
    percentMax: 10.0,
    order: 300,
    colorHex: "#8B4513",
  },
  Umidita: {
    label: "Umidità",
    labelWithArticle: "l'umidità",
    shortLabel: "Umidità",
    unit: "%",
    unitPosition: "right",
    percentMin: 0.0,
    percentMax: 100.0,
    order: 200,
    colorHex: "#7FDBFF",
  },
  Portata: {
    label: "Portata",
    labelWithArticle: "la portata",
    shortLabel: "Portata",
    unit: "l/h",
    unitPosition: "right",
    percentMin: 0.0,
    percentMax: 2400.0,
    order: 2100,
    colorHex: "#013220",
  },
  PotenzaMotore: {
    label: "Potenza motore",
    labelWithArticle: "la potenza motore",
    shortLabel: "Potenza",
    unit: "%",
    unitPosition: "right",
    percentMin: 0.0,
    percentMax: 100.0,
    order: 2000,
    colorHex: "#2ECC40",
  },
  Saturazione: {
    label: "Saturazione",
    labelWithArticle: "la saturazione",
    shortLabel: "Saturazione",
    unit: "%",
    unitPosition: "right",
    percentMin: 0.0,
    percentMax: 100.0,
    order: 600,
    colorHex: "#A569BD",
  },
  ConcentrazioneRifrattometrica: {
    label: "Concentrazione Rifrattometrica",
    labelWithArticle: "la concentrazione rifrattometrica",
    shortLabel: "Cr",
    unit: "%",
    unitPosition: "right",
    percentMin: 0.0,
    percentMax: 20.0,
    order: 700,
    colorHex: "#17A589",
  },
  PH: {
    label: "pH",
    labelWithArticle: "il pH",
    shortLabel: "pH",
    unit: null,
    unitPosition: "right",
    percentMin: 0.0,
    percentMax: 10.0,
    order: 800,
    colorHex: "#F39C12",
  },
} as const;
